import { Navigate, useParams } from 'react-router-dom';
import { useTenantConfig } from '../../context/TenantConfigContext';

const ProtectedRoute = ({ pageKey, children }) => {
  const { config } = useTenantConfig();
  const { client } = useParams();

  if (config.disabledPages?.includes(pageKey)) {
    return <Navigate to={`/${client}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
